<template>
  <div id="contenedor-eliminar-oficio-autorizacion">
    <v-card class="rounded-lg">
      <!-- Header -->
      <v-card-title class="d-flex align-center py-4">
        <v-avatar
          :color="puedeEliminar ? 'error' : 'warning'"
          size="40"
          class="mr-3">
          <v-icon dark>
            {{ puedeEliminar ? 'mdi-delete-alert' : 'mdi-alert-circle' }}
          </v-icon>
        </v-avatar>
        <div>
          <span class="text-h6">
            {{ puedeEliminar ? 'Eliminar Oficio' : 'No se puede eliminar' }}
          </span>
          <div class="text-caption grey--text">
            {{ oficioAutorizacionEliminar.numero }}
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-6">
        <!-- Alerta de recursos relacionados -->
        <v-alert
          v-if="!puedeEliminar"
          type="warning"
          outlined
          class="mb-4">
          <div class="d-flex align-center">
            <v-icon color="warning" class="mr-2">mdi-link-variant</v-icon>
            <div>
              <div class="font-weight-medium">
                Este oficio tiene recursos relacionados
              </div>
              <div class="text-caption">
                Elimine primero los {{ cantidadRecursos }} recurso(s) asignado(s)
                antes de poder eliminar el oficio.
              </div>
            </div>
          </div>
        </v-alert>

        <!-- Confirmación de eliminación -->
        <v-alert
          v-else
          type="error"
          outlined
          class="mb-4">
          <div class="font-weight-medium">
            ¿Está seguro de eliminar este oficio?
          </div>
          <div class="text-caption">
            Esta acción no se puede deshacer.
          </div>
        </v-alert>

        <!-- Información del oficio -->
        <v-card outlined class="rounded-lg">
          <v-list-item>
            <v-list-item-avatar>
              <v-avatar
                :color="getTipoColor"
                size="40">
                <v-icon dark small>
                  {{ getTipoIcon }}
                </v-icon>
              </v-avatar>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ oficioAutorizacionEliminar.numero }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-chip
                  x-small
                  :color="getTipoColor"
                  text-color="white"
                  class="mr-2">
                  {{ oficioAutorizacionEliminar.tipo }}
                </v-chip>
                <span class="text-caption">
                  {{ formatearFecha(oficioAutorizacionEliminar.fecha) }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <div class="text-right">
                <div class="font-weight-bold">
                  {{ oficioAutorizacionEliminar.importe | currency }}
                </div>
                <div class="text-caption grey--text">
                  {{ cantidadRecursos }} recursos
                </div>
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          text
          @click="cerrar"
          class="mr-2">
          Cancelar
        </v-btn>
        <v-btn
          v-if="puedeEliminar"
          color="error"
          @click="mixEliminarOficio"
          :loading="enviandoFormulario"
          :disabled="enviandoFormulario">
          <v-icon left small>mdi-delete</v-icon>
          Eliminar
        </v-btn>
        <v-btn
          v-else
          color="primary"
          @click="cerrar">
          Entendido
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import MixOficioAutorizacion from './mixOficiosAutorizacion';

export default {
  name: 'EliminarOficioAutorizacion',
  mixins: [MixOficioAutorizacion],
  props: {
    oficioAutorizacionEliminar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  filters: {
    currency(value) {
      if (!value && value !== 0) return '$0.00';
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency: 'MXN',
      }).format(value);
    },
  },
  computed: {
    puedeEliminar() {
      return !this.oficioAutorizacionEliminar.detalles
        || this.oficioAutorizacionEliminar.detalles.length === 0;
    },
    cantidadRecursos() {
      return this.oficioAutorizacionEliminar.detalles?.length || 0;
    },
    getTipoColor() {
      return this.oficioAutorizacionEliminar.tipo === 'AUTORIZACIÓN'
        ? 'success'
        : 'error';
    },
    getTipoIcon() {
      return this.oficioAutorizacionEliminar.tipo === 'AUTORIZACIÓN'
        ? 'mdi-check-circle'
        : 'mdi-close-circle';
    },
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    formatearFecha(fecha) {
      if (!fecha) return '';
      return new Date(`${fecha} 00:00:00`).toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
